import { mapActions,mapState,mapGetters } from 'vuex';
import NotificationMixin from './NotificationMixin';

export default {
  data: () => ({
    userAccess: [],
  }),
  mixins: [NotificationMixin],
  mounted() {
    if (! this.dataUser('access')) {
      if (this.$root.isConnected) {
        this.userGetData({data: 'access'});
      }
    } else {
      this.userAccesList = this.dataUser('access');
    }
  },
  computed: {
    menusFilterAccess() {
      let filtermenu = this.menus.filter(this.menuHasAccess);
      for (var i = 0; i < filtermenu.length; i++) {
        filtermenu[i].children = filtermenu[i].children.filter(this.menuHasAccess);
      }
      return filtermenu;
    },

    ...mapState('user', {
      updatedata: 'updatedata',
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    userAccesList: {
      get() {
        let access = [];
        for (var i = 0; i < this.userAccess.length; i++) {
          access[i] = this.userAccess[i].name;
        }
        return access;
      },
      set(value) { this.userAccess = value; }
    }
  },
  methods: {
    ...mapActions({
      userGetData: 'user/data'
    }),
    menuHasAccess(menu) {
      if (menu.access.length == 0) {
        return true;
      }
      for (var y = 0; y < menu.access.length; y++) {
        if ( this.userAccesList.includes(menu.access[y]) ) {
          return true;
        }
      }
      return false;
    },
    userHasAccess(link) {

      for (var i = 0; i < this.userAccesList.length; i++) {
        if (this.userAccesList[i] == link) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword' && this.$route.name != 'Login') this.$router.push({ name: `Login` });
      }else {
        message && this.showError(message);
      }
    },
    updatedata: function (updatedata) {
      if (updatedata == 'access') {
        this.userAccesList = this.dataUser('access');
      }
    },
    actioned(actioned) {
      if ( (this.action == 'login' &&  actioned.regen_password != true) || (this.action == 'edit/password' ) ) {
        if (! this.dataUser('access')) {
          this.userGetData({data: 'access'});
        }
      }
    },
  }
};
